import { Intent, Tag } from '@blueprintjs/core';

import { isEnterprisePlan, isGuardianPlan, isTrialPlan, type PlanType, PlanTypeReadableNames } from '../model';

import './PlanTypeTag.scss';

function getPlanIntent(planType: PlanType): Intent {
  if (isEnterprisePlan(planType) || isGuardianPlan(planType)) {
    return Intent.SUCCESS;
  }
  if (isTrialPlan(planType)) {
    return Intent.WARNING;
  }
  return Intent.PRIMARY;
}

export function PlanTypeTag({ planType }: { planType: PlanType }) {
  return (
    <Tag round minimal intent={getPlanIntent(planType)} className="PlanTypeTag bp4-text-small">
      {PlanTypeReadableNames[planType]}
    </Tag>
  );
}
